import React, { useEffect, useState } from 'react';
import { Confirmation, BookingSummarySkeleton } from 'gigi-component-library';
import { useDispatch, useSelector } from 'react-redux';
import { signIn } from "gigi-api-layer";
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../utility/constants';
import { BookingDetailsAPI, FareRulesforPNRAPI } from 'gigi-api-layer';
import { SegmentConverter } from './segmentTranslation';
import { EVENT_TYPES, TRACKING_DATA, trackEvent } from '../../utility/TrackingRules';

const BookingConfirmationComponent = () => {
    // const dispatch = useDispatch();
    // const [callSignInAPI, signInData, signInProgress, signInError]= signIn()
    const navigate = useNavigate();
    const bookingData = useSelector((state: any) => state.bookingResult.booking);
    const correlationId = useSelector((state: any) => state.search.correlationId);
    let quoteBookingData = useSelector((state: any) => state.quoteBookingResult.quoteBooking);
    let giftCardPayload = useSelector((state: any) => state.giftCardResult.giftCard);
    let recordLocator= bookingData?.recordLocator;

    const bookingAgency = useSelector((state: any) => state.languageChange.bookingAgency);
    const bookingAgent = useSelector((state: any) => state.languageChange.bookingAgent);
    const flowFrom = useSelector((state: any) => state.bookingResult.flowFrom);
    const segmentData = useSelector((state: any) => state.bookingResult.segment);
    const language = useSelector((state: any) => state.languageChange.language);

    // useEffect(()=>{
    //     if(signInData && signInData.hasOwnProperty('accessToken') ){
    //         navigate(ROUTES.searchWidgetPage)
    //     }
    // },[signInData])
    const [callGetBookingDetails, getBookingDetailsData, getBookingDetailsInProgress, getBookingDetailsError]= BookingDetailsAPI()
    const [faresRulesForPNR, fareRulesForPNRData, fareRulesForPNRInProgress, fareRulesForPNRError] = FareRulesforPNRAPI()
    const [segmentsData, setSegmentsData] = useState([])

    useEffect(() => {
        if(bookingData){
            fetchBookingDetails();
            fetchFareRulesForPNR()
        }
    }, [bookingData]);

    const fetchBookingDetails = async () => {
        let payload = {
            "recordLocator": recordLocator,
            "providerId": "S1_ADT",
            "agency": bookingAgency,
            "agent": bookingAgent
        }
        try {
            let res = await callGetBookingDetails(payload,correlationId);
            // handle the response
        } catch (error) {
            // handle the error
        }
    };

    const fetchFareRulesForPNR= async ()=>{
        let payload = {
            "PNR": recordLocator,
            "agency": bookingAgency,
            "agent": bookingAgent
        }
        try {
            let res = await faresRulesForPNR(payload,correlationId);
            // handle the response
        } catch (error) {
            // handle the error
        }

    }

    function mapBookingDataToTargetStructure(data) {
        const { jsonresponse, originalrequest, ...allData } = data;
        const paxFares = originalrequest.passengers || [];
        const paxCounts = { Adult: 0, Child: 0, Infant: 0 };
      
        // Count passenger types
        paxFares.forEach(pax => {
          const type = pax.paxType;
          if (type === 'Adult') paxCounts.Adult += 1;
          if (type === 'Child') paxCounts.Child += 1;
          if (type === 'Infant') paxCounts.Infant += 1;
        });

        const getFrequentFlyer = () => {
            return paxFares.some(t => t.memberships?.length) ? 'true' : 'false';
          };
      
        // First & last flight for origin/destination
        const allFlights = originalrequest?.segment?.flatMap(s => s.flights);
        const firstFlight = allFlights[0];
        let lastFlight = allFlights[allFlights.length - 1];
        if(firstFlight?.departureAirport === lastFlight?.arrivalAirport){
            const firstFlightData = originalrequest?.segment?.[0]?.flights || [];
            lastFlight = firstFlightData[firstFlightData?.length - 1] || lastFlight;
        }
        let productInfo = originalrequest?.segment?.map(segment => {
            let productId = segment.flights.map(flight => {
                return flight.number;
            });
            let productName = segment.flights.map(flight => {
                return flight.operatingCarrier;
            })
            return {productInfo: {
                productId: productId?.join(":"),
                productName: productName?.join(":")
            }}
        })

      
        // Calculate trip duration
        const departure: any = new Date(firstFlight.departureDateTime);
        const returnDate: any = new Date(lastFlight.arrivalDateTime);
        const duration: any = Math.ceil((returnDate - departure) / (1000 * 60 * 60 * 24));
      
        // Payments
        const firstPayment = Array.isArray(jsonresponse.payments) ? jsonresponse.payments[0] : jsonresponse.payments;
        const billing = firstPayment?.creditCard?.billingAddress || {};
        const itineraryFare = jsonresponse?.bookingDetails?.itineraryFare || jsonresponse?.itineraryFare || {};
        let totalInsuranceAmount = 0;

        quoteBookingData?.quoteTranslation?.paxInsArray?.forEach((paxItem: any) => {
            totalInsuranceAmount += Number(paxItem.amount) || 0;
        });
        // Format result
        return {
          transactionID: allData.recordlocator,
          transactionStatus: jsonresponse?.bookingStatusDetail?.status || jsonresponse?.bookingStatus || "",
          bookingDate: jsonresponse.bookingDate,
          bookingOrigin: firstFlight.departureAirport || "",
          bookingDestination: lastFlight.arrivalAirport || "",
          currentDate: new Date().toISOString(),
          returnDate: returnDate.toISOString(),
          tripDuration: `${duration} days`,
          adultTravelers: paxCounts.Adult,
          childTravelers: paxCounts.Child,
          infantTravelers: paxCounts.Infant,
          seatSelection: "false", // Assuming false as seat map is going to change
          frequentFlyer: getFrequentFlyer(),
          brandId: originalrequest?.segment?.map(s => s?.brand?.map(f => f?.brandName).join(":")).join(":"), // Unique brand IDs joined
          profile: {
            address: {
              street: billing.line1 || "",
              city: billing.city?.name || "",
              stateProvince: billing.state?.name || "",
              postalCode: billing.postalCode || "",
              country: billing.country?.name || ""
            }
          },
          total: {
            totalPrice: itineraryFare?.totalAmount?.amount || "",
            basePrice: itineraryFare?.baseAmount?.amount || "",
            currency: itineraryFare?.totalAmount?.currency || "CAD",
            tax: itineraryFare?.totalTaxes?.amount || "",
            couponName: originalrequest?.promo?.couponName || "",
            couponPrice: originalrequest?.promo?.couponPrice || "",
            seatSelectionAmount: 0,
            priceChange: ""
          },
          insurance: {
            noofInsuredPassenger: quoteBookingData?.quoteTranslation?.paxInsArray?.length || 0,
            totalAmount: totalInsuranceAmount || 0
          },
          attributes: {
            paymentMethod: firstPayment?.type || "",
            paymentType: firstPayment?.creditCard?.cardType || ""
          },
          item: productInfo
        };
      }
      

    // useEffect(() => {
    //     trackEvent(EVENT_TYPES.DOM_READY, TRACKING_DATA.BOOKING_CONFIRMATION);
    // }, []);

    useEffect(() => {
        if (getBookingDetailsData && getBookingDetailsData?.originalrequest?.segment && flowFrom == 'booking') {
            let transaction = mapBookingDataToTargetStructure(getBookingDetailsData);
            const seg = new SegmentConverter(getBookingDetailsData?.originalrequest?.segment);
            const convertedResponse = seg.convertSegments();
            setSegmentsData(convertedResponse.segments);
            let bookingConfirmationData = TRACKING_DATA.BOOKING_CONFIRMATION
            const data = {
                ...bookingConfirmationData,
                digitalData: {
                    ...bookingConfirmationData.digitalData,
                    page: {
                        ...bookingConfirmationData.digitalData.page,
                        transaction: transaction
                    }
                }
            };
            trackEvent(EVENT_TYPES.DOM_READY, data);
        }
    }, [getBookingDetailsData]);

    return (
        <>
            <Confirmation
                getBookingDetailsData={getBookingDetailsData}
                getBookingDetailsInProgress={getBookingDetailsInProgress}
                faresRulesForPNR={faresRulesForPNR}
                fareRulesForPNRData={fareRulesForPNRData}
                quoteBookingData={quoteBookingData}
                giftCardPayload={giftCardPayload}
                flowFrom={flowFrom}
                bookingData={bookingData}
                segmentsData={segmentsData}
                language={language}
            />
        </>
    );
};

export default BookingConfirmationComponent;